import { render, staticRenderFns } from "./refGOST2FTTable.vue?vue&type=template&id=99decff6"
import script from "./refGOST2FTTable.vue?vue&type=script&lang=js"
export * from "./refGOST2FTTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports